import { Navigate } from "react-router-dom";

interface JwtPayload {
  role?: string;
  [key: string]: any;
}

const decodeToken = (token: string): JwtPayload | null => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

interface PrivateRouteProps {
  element: JSX.Element;
  requiredRoles?: string[];
}

const PrivateRoute = ({ element, requiredRoles }: PrivateRouteProps) => {
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const payload = token ? decodeToken(token) : null;

  const userRole = payload?.role || null;
  if (requiredRoles && userRole && !requiredRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default PrivateRoute;
